<template>
  <div class='oj_match'>
    <el-menu
      :default-active='this.$route.path'
      class='el-menu-demo'
      mode='horizontal'
      background-color='#545c64'
      text-color='#fff'
      active-text-color='#ffd04b'
      :router='true'
    >
      <el-submenu index='/home/oj/match/online_match'>
        <template slot='title'>竞赛列表</template>
        <el-menu-item index='/home/oj/match/online_match'
          >上线竞赛</el-menu-item
        >
        <el-menu-item index='/home/oj/match/offline_match'
          >下线竞赛</el-menu-item
        >

      </el-submenu>
       <el-submenu index='/home/oj/match/online_test'>
          <template slot='title'>测验列表</template>
          <el-menu-item index='/home/oj/match/online_test'
            >上线测验</el-menu-item
          >
          <el-menu-item index='/home/oj/match/offline_test'
            >下线测验</el-menu-item
          >
        </el-submenu>
      <!-- <el-menu-item index='/home/oj/match/online_match'>上线竞赛</el-menu-item>
      <el-menu-item index='/home/oj/match/offline_match'>下线竞赛</el-menu-item>
      <el-menu-item index='/home/oj/match/online_test'>上线测验</el-menu-item>
      <el-menu-item index='/home/oj/match/offline_test'>下线测验</el-menu-item> -->
    </el-menu>
    <div class='oj_match_main'>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'oj_match',
  data() {
    return {};
  },
  methods: {}
};
</script>

<style  scoped>
.oj_match_main {
  margin-top: 10px;
}
</style>